'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Provider = exports.inject = exports.connect = exports.useStaticRendering = exports.Observer = exports.observer = undefined;

var _observer = require('./observer');

Object.defineProperty(exports, 'observer', {
    enumerable: true,
    get: function get() {
        return _observer.observer;
    }
});
Object.defineProperty(exports, 'Observer', {
    enumerable: true,
    get: function get() {
        return _observer.Observer;
    }
});
Object.defineProperty(exports, 'useStaticRendering', {
    enumerable: true,
    get: function get() {
        return _observer.useStaticRendering;
    }
});

var _connect = require('./connect');

Object.defineProperty(exports, 'connect', {
    enumerable: true,
    get: function get() {
        return _connect.connect;
    }
});

var _inject = require('./inject');

Object.defineProperty(exports, 'inject', {
    enumerable: true,
    get: function get() {
        return _inject.inject;
    }
});

var _Provider = require('./Provider');

Object.defineProperty(exports, 'Provider', {
    enumerable: true,
    get: function get() {
        return _Provider.Provider;
    }
});

var _mobx = require('mobx');

var _preact = require('preact');

if (!_preact.Component) {
    throw new Error('mobx-preact requires Preact to be available');
}
if (!_mobx.extras) {
    throw new Error('mobx-preact requires mobx to be available');
}


// WEBPACK FOOTER //
// ../node_modules/mobx-preact/lib/index.js